export default __webpack_public_path__ + "static/media/Roboto-Bold.46b38206.woff";